function initStickyNavAfterSection() {
  const stickyNav = document.querySelector('.sticky-nav');
  const triggerSection = document.getElementById('select-metafield_tag');

  if (!stickyNav || !triggerSection) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!entry.isIntersecting && scrollTop > triggerSection.offsetTop) {
        // On a scrollé APRES la section
        stickyNav.classList.remove('opacity-0', 'hidden', 'pointer-events-none', '-translate-y-2');
        stickyNav.classList.add('opacity-100', 'translate-y-0');
      } else {
        // On est AVANT la section ou tout en haut
        stickyNav.classList.add('opacity-0', 'hidden', 'pointer-events-none', '-translate-y-2');
        stickyNav.classList.remove('opacity-100', 'translate-y-0');
      }
    },
    {
      root: null,
      threshold: 0,
    },
  );

  observer.observe(triggerSection);
}

document.addEventListener('DOMContentLoaded', () => {
  initStickyNavAfterSection();
});
